import { __rest } from "tslib";
import ExclamationCircleFilled from '@haier/icons/ExclamationCircleFilled';
import classNames from 'classnames';
import useMergedState from 'rc-util/lib/hooks/useMergedState';
import KeyCode from 'rc-util/lib/KeyCode';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import Popover from '../popover';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
import { cloneElement } from '../_util/reactNode';
import { Overlay } from './PurePanel';
const Popconfirm = React.forwardRef((props, ref) => {
    useBuriedPoint('Popconfirm');
    const { getPrefixCls } = React.useContext(ConfigContext);
    const [open, setOpen] = useMergedState(false, {
        value: props.open !== undefined ? props.open : props.visible,
        defaultValue: props.defaultOpen !== undefined ? props.defaultOpen : props.defaultVisible,
    });
    // const isDestroyed = useDestroyed();
    const settingOpen = (value, e) => {
        var _a, _b;
        setOpen(value, true);
        (_a = props.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(props, value, e);
        (_b = props.onOpenChange) === null || _b === void 0 ? void 0 : _b.call(props, value, e);
    };
    const close = (e) => {
        settingOpen(false, e);
    };
    const onConfirm = (e) => { var _a; return (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(this, e); };
    const onCancel = (e) => {
        var _a;
        settingOpen(false, e);
        (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(this, e);
    };
    const onKeyDown = (e) => {
        if (e.keyCode === KeyCode.ESC && open) {
            settingOpen(false, e);
        }
    };
    const onOpenChange = (value) => {
        const { disabled = false } = props;
        if (disabled) {
            return;
        }
        settingOpen(value);
    };
    const { prefixCls: customizePrefixCls, placement = 'top', trigger = 'click', okType = 'primary', icon = React.createElement(ExclamationCircleFilled, null), children, overlayClassName } = props, restProps = __rest(props, ["prefixCls", "placement", "trigger", "okType", "icon", "children", "overlayClassName"]);
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const prefixClsConfirm = getPrefixCls('popconfirm', customizePrefixCls);
    const overlayClassNames = classNames(prefixClsConfirm, overlayClassName);
    return (React.createElement(Popover, Object.assign({}, restProps, { trigger: trigger, prefixCls: prefixCls, placement: placement, onOpenChange: onOpenChange, open: open, ref: ref, overlayClassName: overlayClassNames, _overlay: React.createElement(Overlay, Object.assign({ okType: okType, icon: icon }, props, { prefixCls: prefixCls, close: close, onConfirm: onConfirm, onCancel: onCancel })) }), cloneElement(children, {
        onKeyDown: (e) => {
            var _a, _b;
            if (React.isValidElement(children)) {
                (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            }
            onKeyDown(e);
        },
    })));
});
export default Popconfirm;
